import { render, staticRenderFns } from "./MigrationsValidationTable.vue?vue&type=template&id=4528ef5a"
import script from "./MigrationsValidationTable.vue?vue&type=script&lang=js"
export * from "./MigrationsValidationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports